export default class UserEmails {
  private _activities: boolean;
  private _news: boolean;
  private _prospectInterest: boolean;

  constructor(activities: boolean, news: boolean, prospect_interest: boolean) {
    this._activities = activities;
    this._news = news;
    this._prospectInterest = prospect_interest;
  }

  get activities(): boolean {
    return this._activities;
  }

  get news(): boolean {
    return this._news;
  }

  get prospect_interest(): boolean {
    return this._prospectInterest;
  }

  public copyWith({
    activities,
    news,
    prospect_interest,
  }: {
    activities?: boolean;
    news?: boolean;
    prospect_interest?: boolean;
  }): UserEmails {
    return new UserEmails(
      activities ?? this._activities,
      news ?? this._news,
      prospect_interest ?? this._prospectInterest,
    );
  }

  static fromFirestoreMap(data: Record<string, any>): UserEmails {
    return new UserEmails(data?.activities, data?.news, data?.prospect_interest);
  }

  toPatch(): Record<string, any> {
    return {
      activities: this._activities,
      news: this._news,
      prospect_interest: this._prospectInterest,
    };
  }
}
